import React from "react";
import "../assets/css/Contact.css";
import { FaMapMarkerAlt } from "react-icons/fa";


const ContactLocations = () => {
  return (
    <section className="contact-location-section">
      <div className="container">
        <h2 className="text-center locations-text mb-5">
          Locations
        </h2>

        <div className="location-box">
          <div className="text-center mb-4">
            <i className="fa-solid fa-location-dot location-icon"></i>

            <h5><FaMapMarkerAlt className="logo-india me-1" />INDIA</h5>
                                        <div className="contact-border-half-red"></div>


            <h4 className="mb-5">INNOTHRUST</h4>
          </div>

          <div className="row">
            <div className="col-md-6 mb-4 text-center">
              <p className="address-text">
                No.13,1/12/13/5, Ground Floor,
                Chinappa Layout, Kodighalli,
                KR Puram, Bangalore,
                Karnataka - 560067
              </p>
            </div>

            <div className="col-md-6 mb-4 text-center">
              <p className="address-text">
                D.No. 54, 1st Floor, Above Hang
                Out, Bharathi Park Rd, 7th cross,
                Saibaba colony,
                Coimbatore-641011.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactLocations;